import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { MaeCorreoE,MaeCorreoM /*, MaeCorreoSend,CorreoRspta,ListaM*/} from '../model/mae-correo-bean';
import { Response_dml_bean,ResponseMensaje } from '../model/response-dml';
import { AdminCredential } from '../model/request_credenciales';

@Injectable({
  providedIn: 'root'
})
export class MaeCorreoService {

  baseURL = environment.urlBase;
  userCons = environment.usuarioConstancias;
  passCons = environment.claveConstancias;
  constructor(private httpclient:HttpClient) {}

  proceDml(maeCorreoE:MaeCorreoE): Observable<Response_dml_bean> {

    var url  : string;
    url = this.baseURL + 'correo/api/update';

    var body : string;
    body = JSON.stringify(maeCorreoE);

    let headers = new HttpHeaders({
      'Content-Type' : 'application/json; charset=utf-8',
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });

    return this.httpclient.put<Response_dml_bean>(url,body,{headers});

  }

  get(): Observable<MaeCorreoE[]> {

    var url  : string;
    url = this.baseURL + 'correo/api/get';

    let headers = new HttpHeaders({
      'Authorization':  'Basic ' + btoa(this.userCons + ':' + this.passCons)
    });
    return this.httpclient.get<MaeCorreoE[]>(url,{headers})

  }
/*
  generar(P_C_DOCUMENTO: string): Observable<MaeCorreoM[]> {

    var url  : string;
    url = this.baseURL + 'correo/api/generar';

    let params = new HttpParams()
    .set('P_C_DOCUMENTO', P_C_DOCUMENTO);

    return this.httpclient.get<MaeCorreoM[]>(url, {params: params})

  }
  send(maeCorreoSend:MaeCorreoSend): Observable<CorreoRspta> {

    var url  : string;
    url = this.baseURLMail+'api/notificacion/registrar';

    var body : string;
    body = JSON.stringify(maeCorreoSend);

    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json; charset=utf-8');

    return this.httpclient.post<CorreoRspta>(url,body,{headers});

  }

  getSistemas(): Observable<ListaM> {

    var url  : string;
    url = this.baseURLMail + 'api/maestra/listar';

    return this.httpclient.get<ListaM>(url)

  }
*/
}
